<template>
  <a
    href="javascript:;"
    class="movie-cover"
    :class="more"
    @click="onClick"
    @touchstart.passive="onTouchStart"
    @touchend.passive="onTouchEnd"
    @touchmove.passive="onTouchEnd"
  >
    <span class="bg" :style="{backgroundImage:'url('+value.pic+')'}"></span>
    <slot>
      <div>{{value.title}}</div>
      <div>{{value.actor}}</div>
      <div>{{value.director}}</div>
      <div v-if="more==='add'">发布日期
        <br>
        {{value.addtime | date}}
      </div>
      <div v-if="more==='update'">更新日期
        <br>
        {{value.modifytime | date}}
      </div>
      <div v-if="more==='simple'">{{value.addtime | date}}</div>
    </slot>
  </a>
</template>
<script>
export default {
  name: 'MovieCover',
  props: {
    value: {},
    event: {
      type: String,
      default: ''
    },
    more: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      tap: 0
    }
  },
  methods: {
    onTouchStart() {
      this.tap = setTimeout(() => {
        this.$emit('longTap', this.value)
      }, 1000)
    },
    onTouchEnd() {
      clearTimeout(this.tap)
    },
    onClick() {
      if (this.event) {
        this.$emit(this.event, this.value)
      } else {
        this.$router.push({
          name: 'movie',
          params: {
            movid: this.value.movid
          }
        })
      }
    }
  }
}
</script>
<style scoped lang='scss'>
.movie-cover {
  display: inline-block;
  width: rem(234);
  height: rem(446);
  padding-bottom: 4px;
  background-color: $color-white;
  &:active {
    background-color: rgba(0, 0, 0, 0.1);
  }
  &.add,
  &.update {
    height: rem(500);
  }
  &.simple {
    height: rem(400);
  }
  .bg {
    display: block;
    height: rem(320);
    background-size: cover;
    background-repeat: no-repeat;
    background-position: top;
  }
  > div {
    font-size: rem(28);
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    &:nth-child(5) {
      font-size: rem(24);
    }
  }
}

@media screen and (min-width: 768px) {
  .movie-cover {
    width: rem(117);
    height: rem(220);
    .bg {
      height: rem(159);
    }
    > div {
      font-size: rem(14);
    }
  }
}

@media screen and (min-width: 1024px) {
  .movie-cover {
    width: rem(88);
    height: rem(164);
    .bg {
      height: rem(120);
    }
    > div {
      font-size: rem(10);
    }
  }
}
</style>



// WEBPACK FOOTER //
// MovieCover.vue?18547bbe